// extracted by mini-css-extract-plugin
export var navBar = "MobileSideNavItems-module--nav-bar--7ec94";
export var navFirstSubItemGroup = "MobileSideNavItems-module--nav-first-sub-item-group--cbe5f";
export var navFooter = "MobileSideNavItems-module--nav-footer--bdd79";
export var navItem = "MobileSideNavItems-module--nav-item--ea7e6";
export var navItemFocus = "MobileSideNavItems-module--nav-item-focus--3815d";
export var navItemsContainer = "MobileSideNavItems-module--nav-items-container--99b1e";
export var navSubItemGroup = "MobileSideNavItems-module--nav-sub-item-group--13dad";
export var navSubItemHeader = "MobileSideNavItems-module--nav-sub-item-header--cba6e";
export var navSubItemHeaderOpen = "MobileSideNavItems-module--nav-sub-item-header-open--28d69";